import { isAcceptedFile } from '@/entities/brief';

export interface FileFieldConfig {
  acceptedMimeTypes?: string[];
  maxSizeBytes?: number;
  maxCount?: number;
}

export type FileRejectionReason = 'type' | 'size' | 'count';

export interface FileRejection {
  file: File;
  reason: FileRejectionReason;
}

export interface ValidateFilesResult {
  accepted: File[];
  rejected: FileRejection[];
}

/**
 * Pure — rejects each candidate against `config` in order (type, then size, then the running
 * count against `maxCount`), before any upload is attempted. `existingCount` is the number of
 * attachments already on the field, so `maxCount` caps the TOTAL, not just this batch.
 */
export function validateFiles(
  files: File[],
  existingAssetIds: string[],
  config: FileFieldConfig,
): ValidateFilesResult {
  const accepted: File[] = [];
  const rejected: FileRejection[] = [];
  let count = existingAssetIds.length;

  for (const file of files) {
    if (config.acceptedMimeTypes && !isAcceptedFile(file, config.acceptedMimeTypes)) {
      rejected.push({ file, reason: 'type' });
      continue;
    }
    if (config.maxSizeBytes != null && file.size > config.maxSizeBytes) {
      rejected.push({ file, reason: 'size' });
      continue;
    }
    if (config.maxCount != null && count >= config.maxCount) {
      rejected.push({ file, reason: 'count' });
      continue;
    }
    accepted.push(file);
    count += 1;
  }

  return { accepted, rejected };
}
